import { css } from '@emotion/css'
import { FormControl, InputLabel, Tooltip } from '@mui/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import { getStyles } from 'src/utils/utils/commonUtils'
import commonStyles from '../../../../styles/commonStyles'
import inputFieldStyles from '../styles/inputFieldStyles'

function SelectInputField({
  items,
  propName,
  styles,
  multiple,
  defaultValue,
  showFullText,
  placeholder,
  displayEmpty,
  ...props
}) {
  const classes = {
    ...getStyles(commonStyles, props),
    ...getStyles(inputFieldStyles),
  }
  const complexKey = typeof items[0]?.key === 'object'
  const renderValue = (value) => {
    const item = items.find((el) => {
      let itemValue = el.value || el
      return itemValue == props.value || value == itemValue
    })

    return (
      <Typography
        variant={props.size === 'small' ? 'body2' : 'subtitle1'}
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {!item
          ? '-'
          : complexKey
            ? item?.key?.name
            : (typeof item.key === 'function' ? item.key() : item.key) || item}
      </Typography>
    )
  }

  return (
    <FormControl
      fullWidth={props.fullWidth}
      size={props.size}
      sx={props.FormControlSx}
    >
      <InputLabel
        sx={{
          color: props.error
            ? '#EA2020'
            : props.disabled
              ? 'rgba(0, 0, 0, 0.38)'
              : null,
        }}
      >
        {props.label}
      </InputLabel>
      <Select
        className={css(
          classes.selectField,
          props.fullWidth && classes.fullWidth,
        )}
        MenuProps={{
          sx: {
            ...classes.selectMenu(props),
            left: showFullText ? '' : undefined,
            right: showFullText ? '15px!' : undefined,
          },
        }}
        sx={{
          width: props.width,
          minWidth: props.minWidth,

          ...(styles || {}),
        }}
        inputProps={{
          error: props.error,
          placeholder: placeholder ?? undefined,
        }}
        onClick={(e) => {
          if (!multiple) {
            e.stopPropagation()
          }
        }}
        renderValue={props.renderValue || renderValue}
        defaultValue={props.defaultValue || null}
        displayEmpty={displayEmpty}
        {...props}
      >
        {items.map((item) => {
          return (
            <MenuItem
              key={
                complexKey
                  ? item?.key?.name
                  : item.key
                    ? typeof item.key === 'function'
                      ? item.key()
                      : item.key
                    : item
              }
              value={
                !item.value && typeof item.value === 'string'
                  ? ''
                  : item.value || item
              }
              sx={{
                ...classes.menuItem,
                height: showFullText ? 'auto' : '36px',
                ...(complexKey && { height: '48px' }),
                textWrap: showFullText ? 'wrap' : undefined,
                maxWidth: showFullText ? '335px' : undefined,
              }}
              onClick={(e) => {
                if (!multiple) {
                  e.stopPropagation()
                }
              }}
            >
              {complexKey ? (
                <Box className={'fx-col'}>
                  <Typography variant={'subtitle1'}>
                    {item?.key?.name}
                  </Typography>
                  <Typography variant={'caption'}>
                    {item?.key?.description}
                  </Typography>
                </Box>
              ) : item.key ? (
                typeof item.key === 'function' ? (
                  item.key()
                ) : item.key.length > 40 ? (
                  <Tooltip
                    title={item.key && item.key}
                    placement={'top-start'}
                    TransitionProps={{ timeout: 0 }}
                  >
                    <Typography>{item.key.substring(0, 40) + '...'}</Typography>
                  </Tooltip>
                ) : (
                  <>
                    {item.icon && (
                      <Box sx={{ marginRight: '4px' }}>{item.icon}</Box>
                    )}
                    <Typography>{item.key}</Typography>
                  </>
                )
              ) : (
                item
              )}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default observer(SelectInputField)
